/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_artworkfilter = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {
		
		/*
		Filter: Click
		*/
		$(document).on('click','.js-filter-item',function() {
			specific_artworkfilter.setActive(
				$(this)
			);
		});

		/*
		Information Button: Click to close
		*/
		$(document).on('click','.js-information-button',function() {
			
			if (
				$(this).closest('.box').hasClass('selected')
			) {
				
				specific_artworkfilter.closeInformation();
				
			} else {

				specific_artworkfilter.showInformation(
					$(this)
				);

			}

		});
	
	
	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	this.setActive = function (
		_this
	) {

		/*
		Filter: Remove active class from all items
		*/
		$('.js-filter-item').removeClass('active');
		$('.js-item').hide().removeClass('active');

		/*
		Filter: Set active class on clicked item
		*/
		if (
			_this.data('filter') == 'all'
		) {
			
			$('.js-item').show().addClass('active');

			$('.information-button').hide();
			
		} else {

			$('.js-item[data-category="' + _this.data('filter') + '"]').show().addClass('active');

			$('.information-button').show();
			
		}
		
		_this.addClass('active');

	};

	/*
	Show Information: Show information button
	Show Information: Show information button
	Show Information: Show information button
	Show Information: Show information button
	*/
	this.showInformation = function (
		_this
	) {

		/*
		Close Information: Close information button
		*/
		specific_artworkfilter.closeInformation();

		/*
		Get: Artwork
		*/
		var _artwork = _this.closest('.js-item');

		_artwork.find('.box').addClass('selected');
		
		_artwork.find('.js-information-button').find('.show').hide();
		_artwork.find('.js-information-button').find('.hide').show();

		/*
		Slide Down
		*/
		_artwork.find('.text').stop().slideDown(200);

	};

	/*
	Close Information: Close information button
	Close Information: Close information button
	Close Information: Close information button
	Close Information: Close information button
	*/
	this.closeInformation = function () {
		
		$('.js-information-button').find('.show').show();
		$('.js-information-button').find('.hide').hide();

		$('.box').removeClass('selected');

		/*
		Slide Up
		*/
		$('.text').stop().slideUp(200);

	};
		
}).apply(specific_artworkfilter); 